import { render, staticRenderFns } from "./uploadSucesso.vue?vue&type=template&id=5633ea2c"
import script from "./uploadSucesso.vue?vue&type=script&lang=js"
export * from "./uploadSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports